import React, { FC } from "react";
import { observer } from "mobx-react-lite";
import { makeStyles, Box, TextField, Checkbox } from "@material-ui/core";
import Button from "./Button";
import { Text } from "../components/Text";
import { store } from "../store";

export const CallbackAction: FC = observer(() => {
  const {
    customerName,
    inputEmail,
    allowDiffractionSlot,
    prioritizeLoading,
    driverName,
    horizontalBeamWidth,
    horizontalMaxSize,
    upperFrequency,
    verticalBeamWidth,
    verticalMaxSize,
    setLoading,
    isEmailValid,
    joinMailingList,
    toggleJoinMailing,
    errors,
    setErrors,
  } = store;
  const classes = styles();

  // Bugfix diffractionSlot should be false if prioritizeLoading is true
  const diffSlot = prioritizeLoading ? false : allowDiffractionSlot;

  const sendRequestCall = async () => {
    const url = `/.netlify/functions/RequestCallback`;

    try {
      const body = JSON.stringify({
        customerName,
        inputEmail,
        allowDiffractionSlot: diffSlot,
        prioritizeLoading,
        driverName,
        horizontalBeamWidth,
        horizontalMaxSize,
        upperFrequency,
        verticalBeamWidth,
        verticalMaxSize,
        joinMailingList,
      });

      setLoading(true);
      const response = await fetch(url, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body,
      });
      setLoading(false);
      setErrors([]);
      return response;
    } catch (err) {
      console.log(err);
    }
  };

  const handleRequest = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    let allErrors = [];
    if (!customerName) allErrors.push("Please enter your name");
    if (!isEmailValid) allErrors.push("Please enter a valid email address");
    setErrors(allErrors);
    if (!errors.length) sendRequestCall();
    return false;
  };
  return (
    <Box m={4} maxWidth={530} width={1}>
      <Text align="center" size="large" bold>
        Manufacturers - Let's discuss your design in more detail.
      </Text>
      <form onSubmit={handleRequest}>
        <Box className={classes.inputContainer}>
          <TextField
            InputProps={{ classes: { input: classes.input } }}
            placeholder="NAME"
            className={classes.input}
            type="text"
            value={customerName}
            error={!!errors.find((err) => err.includes("name"))}
            name="customerName"
            variant="filled"
            onChange={(e) =>
              (store[e.currentTarget.name] = e.currentTarget.value)
            }
          />
        </Box>
        <Box className={classes.inputContainer}>
          <TextField
            InputProps={{ classes: { input: classes.input } }}
            placeholder="EMAIL"
            className={classes.input}
            type="email"
            value={inputEmail}
            name="inputEmail"
            variant="filled"
            error={!!errors.find((err) => err.includes("email"))}
            onChange={(e) =>
              (store[e.currentTarget.name] = e.currentTarget.value)
            }
          />
        </Box>
        <Box display="flex" className={classes.inputContainer}>
          <Checkbox checked={joinMailingList} onChange={toggleJoinMailing} />
          <Box>
            Join our mailing list to receive information on new product updates,
            information and special offers
          </Box>
        </Box>
        <Box className={classes.errors}>
          {errors.map((error) => (
            <Text size="small" color="error" key={error}>
              {error}
            </Text>
          ))}
        </Box>
        <Button type="submit">REQUEST FOLLOW UP</Button>
      </form>
    </Box>
  );
});

const styles = makeStyles((theme) => ({
  inputContainer: {
    margin: "20px 0px",
  },
  input: {
    width: "100%",
    background: "white",
  },
  errors: {
    marginBottom: 20,
  },
}));
